(ns portal.login-page.hooks
  (:require [clojure.string :as str]
            [common.queries :refer [use-query]]
            [common.url-template :as url-tpl]
            [common.validators.core :as validators]
            [portal.login-page.queries :as q]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-sso-enabled? [email]
  (let [url-context (use-subscribe [:url-context])
        {{:keys [sso-domains]} :data} (use-query (q/sso-config-query url-context))]
    (if (some-> email validators/valid-email?)
      (let [domain (last (str/split email #"@"))]
        (contains? sso-domains domain))
      false)))

(defhook use-sso-login-url [params]
  (let [url-context (use-subscribe [:url-context])
        uri (str (.-protocol js/window.location) "//"
                 (.-host js/window.location)
                 (.-pathname js/window.location))]
    (url-tpl/render :api/sso-login url-context (merge params {:redirect-uri uri}))))

(defhook use-form-errors [form-values validators]
  (let [errors (reduce-kv
                (fn [acc field value]
                  (let [field-error (some (fn [{:keys [validator error-message]}]
                                            (when (not (validator value))
                                              error-message))
                                          (get validators field))]
                    (if (seq field-error)
                      (assoc acc field field-error)
                      acc)))
                {}
                form-values)]
    errors))
